import { useCallback } from 'react';
import { ICompetitionTrade } from '@kattana-io/common';
import {
  IMobileTableScema,
  formatMobileTableData,
} from '../../../../helpers/formatters';
import { formatTimestamp } from '../../../../components/DexTrades/formatters';
import Loader from '../../../../components/common/Loader';
import TableCardMobile from '../../../../molecules/Table/mobile/TableCard';
import NumberDisplay from '../../../../molecules/NumberDisplay';
import TableHeaderMobile from '../../../../molecules/Table/mobile/TableHeader';

interface ICompetitionsTradesTableMobileProps {
  trades: ICompetitionTrade[];
  timezone?: string;
  loading: boolean;
}

const CompetitionsTradesTableMobile = ({
  trades,
  timezone,
  loading,
}: ICompetitionsTradesTableMobileProps) => {
  const schema: IMobileTableScema = {
    row_1: {
      item_1: {
        name: 'Date',
        accessor: 'UpdatedAt',
        parser: (value) => formatTimestamp(value, timezone),
        width: 130,
      },
      item_2: {
        name: 'Pair',
        accessor: 'Pair',
        parser: (value) => value,
      },
    },
    row_2: {
      item_1: {
        name: 'Price',
        accessor: 'PriceAVG',
        parser: (value) => <NumberDisplay value={value} string />,
        width: 130,
        string: true,
      },
      item_2: {
        name: 'Type',
        accessor: 'OrderType',
        parser: (value) => (value === 1 ? 'Market' : 'Limit'),
      },
    },
    row_3: {
      item_1: {
        name: 'Earned points',
        accessor: 'Points',
        parser: (value) => (
          <NumberDisplay value={value} zeroValueDisplay='-' string />
        ),
        width: 130,
        string: true,
      },
      item_2: {
        name: 'Multiplier',
        accessor: 'Multiplier',
        parser: (value) => `x${value}`,
      },
    },
    row_4: {
      item_1: {
        name: 'Value ($)',
        accessor: 'FillBaseAmountUSD',
        parser: (value, row) => (
          <>
            <NumberDisplay value={value} string />
            &nbsp;
            <NumberDisplay
              value={row.FillBaseAmount}
              startSymbol='('
              endSymbol={` ${row.Pair})`}
              string
            />
          </>
        ),
        string: true,
      },
    },
  };

  /**
   * acknowledge flipped when displaying buy/sell
   */
  const getColorForItem = useCallback((row: any) => {
    if (row.OrderSide === 1) {
      return 'green';
    }
    return 'red';
  }, []);

  return (
    <div className='dex_trades_mobile__table'>
      {loading ? (
        <div className='centrify'>
          <Loader />
        </div>
      ) : !trades.length ? (
        <div className='centrify'>No data found</div>
      ) : (
        <>
          <TableHeaderMobile schema={schema} />
          {formatMobileTableData({
            data: trades,
            schema,
            getColorForItem,
          })?.map((row, index) => (
            <TableCardMobile key={index} data={row} />
          ))}
        </>
      )}
    </div>
  );
};

export default CompetitionsTradesTableMobile;
